import ReactGA4 from 'react-ga4';

const GA_TRACKING_ID = process.env.REACT_APP_GA_ID || '';

export const initGA = () => {
  if (GA_TRACKING_ID) {
    ReactGA4.initialize(GA_TRACKING_ID);
  }
};

export const logEvent = (action: string, category: string, label: string) => {
  ReactGA4.event({
    action,
    category,
    label,
  });
};

export const logPageView = (url: string) => {
  ReactGA4.send({ hitType: 'pageview', page: url });
};
